module.exports = __webpack_public_path__ + "static/img/Logo_Redunicre.6f8ca4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paymentMehtods/Logo_Redunicre.png
// module id = 1994
// module chunks = 0